import type { TourDefinition } from '../training/tours';

/**
 * Тур картки матеріалу «Наповнення сайту». Ідентифікатор для реєстрації: 'content-material'.
 * Цілі — атрибути data-tour у картці матеріалу (features/content/material/*).
 */
export const MATERIAL_CARD_TOUR_ID = 'content-material';

export const MATERIAL_CARD_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Картка матеріалу',
  summary: 'Маршрут етапів з умовами переходу, SEO з межами довжин, чек-лист етапу, погодження й ШІ-помічник.',
  missingHint: 'Відкрийте картку матеріалу в розділі «Контент» — підказки прив’яжуться до її розділів.',
  steps: [
    {
      id: 'stage',
      target: 'material-stage',
      title: 'Етап і перехід',
      body: 'Матеріал рухається лише за маршрутом процесу. Перед переходом система показує, чого бракує, і кому піде матеріал далі — наступного відповідального призначено автоматично за роллю. Повернення — лише з кодом причини: так фірма бачить, де губиться якість.',
      placement: 'bottom',
    },
    {
      id: 'seo',
      target: 'material-seo',
      title: 'Title і Description трьома мовами',
      body: 'Лічильник поруч із полем показує довжину й межі з налаштувань фірми: «замало» — бурштиновим, «задовго» — червоним. «Перевірити» звіряє всі мови за правилами типу матеріалу.',
    },
    {
      id: 'checklist',
      target: 'material-checklist',
      title: 'Чек-лист етапу',
      body: 'Позначте виконані пункти, а коли всі обов’язкові готові, — «Позначити перевіреним». Без цього матеріал не перейде далі; будь-яка зміна пунктів знімає позначку.',
    },
    {
      id: 'approvals',
      target: 'material-approvals',
      title: 'Погодження',
      body: 'Оцінку комерційної цінності теми (КЦ) запитують до роботи над текстом — строк рішення 1 робочий день. Відмову можна оскаржити з обґрунтуванням; прострочене погодження видно червоним.',
    },
    {
      id: 'ai',
      target: 'material-ai',
      title: 'ШІ-помічник',
      body: 'Чернетка статті й юридична перевірка «Як було / Що неправильно / Як написати». Результат ШІ завжди потребує перевірки людиною: юридичну точність і публікацію підтверджує автор.',
    },
  ],
};
